import { get } from 'lodash';

export const throwGqlError = error => {
  // We don't throw 401 error ("Unauthorized Request") as it is fully handled in Apollo onError Link
  if (error && get(error, 'graphQLErrors[0].extensions.code') !== 401) {
    throw new Error(error);
  }
};
